import { neutrals, brand, alert } from 'src/theme/colors';
import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { FOCUS_COLOR } from 'src/theme-v2/focus';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    width: 312,
    alignItems: 'center',
    gap: 41,
    justifyContent: 'center',
    flexGrow: 1,
    paddingBottom: 100,
  },
  textLink: {
    color: brand.main.water,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 18,
    borderWidth: 0,
    borderColor: brand.main.water,
  },
  details: {
    alignItems: 'center',
    gap: 20,
  },
  textWrapper: {
    alignItems: 'center',
    gap: 11,
  },
  text: {
    color: neutrals.neutralGrays.tarmac,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 22,
    textAlign: 'center',
    width: 205,
  },
  button: {
    backgroundColor: brand.main.water,
    borderRadius: 100,
    paddingVertical: 8,
    paddingHorizontal: 18,
    shadowColor: brand.main.variations['lighterWater-2'],
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
    width: 283,
    height: 50,
  },
  buttonText: {
    color: neutrals.white,
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 22,
    textAlign: 'center',
  },
  buttonTextPicker: {
    color: neutrals.neutralGrays.graphite,
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 22,
    textAlign: 'center',
  },
  title: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 28,
    textAlign: 'center',
    color: neutrals.neutralGrays.graphite,
  },
  buttonUpload: {
    width: '100%',
    height: '100%',
    borderRadius: 20,
    backgroundColor: neutrals.coldGrays.ice,
    gap: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonUploadIcon: {
    width: 33,
    height: 33,
  },
  buttonUploadText: {
    color: brand.main.water,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 18,
    letterSpacing: 0.16,
    paddingHorizontal: 16,
    textAlign: 'center',
  },
  buttonWrapper: {
    width: '100%',
    height: '100%',
    borderRadius: 20,
  },
  buttonWrapperFocused: {
    borderWidth: 1,
    borderColor: FOCUS_COLOR,
  },
  innerButtonWrapper: {
    width: '100%',
    height: '100%',
  },
  pickerButton: {
    backgroundColor: neutrals.white,
    borderRadius: 100,
    width: 283,
    height: 50,
    paddingVertical: 8,
    paddingHorizontal: 18,
    alignItems: 'center',
    ...getBoxShadow({
      offsetX: 3,
      offsetY: 3,
      blurRadius: 8,
      opacity: 0.1,
      color: neutrals.black,
    }),
  },
  pickerInnerButton: {
    flexDirection: 'row',
  },
  errorWrapper: {
    padding: 16,
  },
  errorWrapperTop: {
    justifyContent: 'center',
  },
  errorWrapperBottom: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  errorInnerWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  errorTitle: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 21,
    color: alert.alertRed,
  },
  errorDescription: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 21,
    color: alert.alertRed,
    paddingLeft: 24,
  },
  icon: {
    width: 16,
    height: 16,
  },
  errorTextLink: {
    color: alert.alertRed,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 16,
    borderBottomWidth: 1,
    borderStyle: 'dotted',
    borderColor: alert.alertRed,
  },
  selectionTopBar: {
    flexDirection: 'row',
    gap: 8,
    alignSelf: 'flex-center',
    paddingHorizontal: 26,
    paddingBottom: 8,
  },
});
